import * as types from './mutation-types';
import { defaultState } from './state';
import * as _ from 'lodash';

const resetState_ = state => {
	// Object.assign(state, defaultState);
	Object.assign(state, _.cloneDeep(defaultState));
};
const resetYnState_ = state => {
	state.msgTypes = [];
	state.gridMsgTypes = [];
	state.msgLocs = [];
	state.gridMsgLocs = [];
	state.msgId = [];
	state.gridMsgID = [];
	// Object.assign(state, defaultState);
};
export default {
	resetYnState_,
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	}
};
